export default __webpack_public_path__ + "static/media/gideon.629fa44d.webp";